<template>
  <section class="project-recent">
    <h3>Derniers commentaires</h3>
    <div class="project-recent__body">
      <div :class="{ active: loading }" class="ui inverted dimmer">
        <div class="ui text loader">
          Récupération des commentaires en cours...
        </div>
      </div>
      <div class="ui relaxed list">
        <div
          v-for="(item, index) in recentComments"
          :key="'comment ' + index"
          class="item"
        >
          <div class="content">
            <FeatureFetchOffsetRoute
              :feature-id="item.related_feature.feature_id"
              :properties="{
                title: item.comment,
                feature_type: { slug: item.related_feature.feature_type_slug },
              }"
            />
            <div class="description">
              <em
                >[ {{ item.created_on
                }}<span v-if="user && item.display_author"
                  >, par {{ item.display_author }}
                </span>
                ]</em
              >
            </div>
          </div>
        </div>
        <p
          v-if="!loading && !recentComments.length"
          class="project-recent__empty"
        >
          Pas de nouveaux commentaires
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import FeatureFetchOffsetRoute from "@/components/Feature/FeatureFetchOffsetRoute";

export default {
  name: "ProjectsLastComments",

  components: {
    FeatureFetchOffsetRoute,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(["user"]),
    ...mapState("projects", ["last_comments"]),
    recentComments() {
      return (this.last_comments || []).slice(0, 5);
    },
  },
};
</script>

<style lang="less" scoped>
.project-recent {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 46%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    margin: 0 0 0.65rem;
    color: #1b2142;
    font-size: 1rem;
    font-weight: 700;
  }
}

.project-recent__body {
  position: relative;
  min-height: 2.5rem;
}

.project-recent__empty {
  margin: 0;
  color: #6b7280;
  font-style: italic;
}

.ui.relaxed.list {
  text-align: center;
}
</style>
